import logo from '../assets/images/daley-seafoods-logo.png'

const WelcomePage = () => (
    <div className="welcome">
        <div>
            <h1 className="welcome__title">Welcome</h1>
            <img className="welcome__photo" src={logo} alt="Daley Seafoods logo" />
        </div>
    </div>
)

export default WelcomePage